<div class="container flex flex-col">
  <div class="flex items-center justify-end">
    <ion-icon class="close-icon cursor-pointer" icon="assets/icon/cross.svg" (click)="cancel()"></ion-icon>
  </div>
  <div class="section-container flex flex-col">
    <ng-container *ngFor="let setting of availableSettings">
      <div class="section" [ngSwitch]="setting">
        <ng-container *ngSwitchCase="'alias'" [ngTemplateOutlet]="aliasTemplate"></ng-container>
        <ng-container *ngSwitchCase="'blankSheets'" [ngTemplateOutlet]="blankSheetsTemplate"></ng-container>
        <ng-container *ngSwitchCase="'coverType'" [ngTemplateOutlet]="coverTypeTemplate"></ng-container>
        <ng-container *ngSwitchCase="'docColor'" [ngTemplateOutlet]="docColorTemplate"></ng-container>
        <ng-container *ngSwitchCase="'binding'" [ngTemplateOutlet]="bindingTemplate"></ng-container>
        <ng-container *ngSwitchCase="'laminating'" [ngTemplateOutlet]="laminatingTemplate"></ng-container>
      </div>

      <ng-template #aliasTemplate>
        <input type="text" class="file-alias-input w-100" [(ngModel)]="alias" />
      </ng-template>
      <ng-template #blankSheetsTemplate>
        <span class="file-text bold">Folios en blanco</span>
        <div class="blank-sheets flex flex-row items-center gap-2.5">
          <div class="flex w-1/2 flex-row items-center justify-between">
            <span class="file-text">Delante: {{ blankSheetsBefore }}</span>
            <app-qty-stepper
              [qty]="blankSheetsBefore"
              [noFullWidth]="true"
              (changes)="changeBlankSheetsQty($event, 'before')"
            ></app-qty-stepper>
          </div>
          <div class="flex w-1/2 flex-row items-center justify-between">
            <span class="file-text">Detrás: {{ blankSheetsAfter }}</span>
            <app-qty-stepper
              [qty]="blankSheetsAfter"
              [noFullWidth]="true"
              (changes)="changeBlankSheetsQty($event, 'after')"
            ></app-qty-stepper>
          </div>
        </div>
      </ng-template>
      <ng-template #coverTypeTemplate>
        <div class="cover laminated-cover flex flex-row items-center justify-between" (click)="openCoverSettings()">
          <div class="flex flex-row items-center">
            <img [src]="fileService.getCoverTypeImage(currentCoverTypeData.value, fileSettings)" alt="" />
            <div class="flex flex-col">
              <span class="file-text bold"
                >{{ currentCoverTypeData?.title }}
                <span *ngIf="!coverLaminated">({{ coverType?.paperWeight }} gr)</span>
              </span>
              <span
                *ngIf="fileService.getDefaultCoverType(pFile, printingGroup.printSettings)?.id === coverType?.id"
                class="file-text"
                >Seleccionada por defecto</span
              >
            </div>
          </div>
          <ion-button color="dark" fill="clear">
            <ion-icon icon="assets/icon/flechaDerecha.svg"></ion-icon>
          </ion-button>
        </div>
      </ng-template>
      <ng-template #docColorTemplate>
        <span class="file-text bold">Documento en:</span>
        <div class="color flex flex-row items-center">
          <ion-radio-group [(ngModel)]="docColor" (ionChange)="restartCoverType()" class="flex flex-row gap-10">
            <ion-radio mode="md" labelPlacement="end" value="bn" class="file-text">Blanco y negro</ion-radio>
            <ion-radio mode="md" labelPlacement="end" value="color" class="file-text">Color</ion-radio>
          </ion-radio-group>
        </div>
      </ng-template>
      <ng-template #bindingTemplate>
        <div
          [ngStyle]="{
            display: [Finishing.BINDING, Finishing.BINDING_LAMINATED].includes(printingGroup.printSettings.finishing)
              ? 'flex'
              : 'none',
          }"
          class="binding container-type flex flex-row items-center justify-between"
          (click)="openIndividualBindingSettings()"
        >
          <div class="flex flex-col gap-1">
            <!-- TIPO DE PLASTIFICADO -->
            <div
              *ngIf="fileSettings.coverLaminated || fileSettings.finishing === Finishing.BINDING_LAMINATED"
              class="binding-option flex flex-row items-center"
            >
              <img src="../../../assets/images/finishings/plastificado.svg" alt="" />
              <div class="flex flex-col">
                <div class="flex flex-row gap-0">
                  <span class="file-text bold">Tipo plastificado:</span>
                  <span class="file-text">{{ fileService.getLaminationTypeName(laminationType) }}</span>
                </div>
                <div class="flex flex-row gap-0">
                  <span class="file-text bold">Grosor:</span>
                  <span class="file-text"
                    >{{ fileService.getLaminationWeightName(laminationWeight, laminationType, coverLaminated) }}
                    <span *ngIf="!coverLaminated">({{ laminationWeight }} micras)</span></span
                  >
                </div>
              </div>
            </div>
            <!-- ANILLA -->
            <div class="binding-option flex flex-row items-center">
              <img [src]="'assets/images/binding/rings/' + fileSettings.ringColor.id + '.png'" alt="" />
              <span class="file-text bold">Anilla: </span>&nbsp;
              <span class="file-text">({{ fileSettings.ringColor.name }})</span>
            </div>
            <!-- TAPA DELANTERA -->
            <div
              *ngIf="
                !fileSettings.coverLaminated &&
                fileSettings.finishing !== Finishing.BINDING_LAMINATED &&
                fileSettings.pageSize !== PageSize.A3
              "
              class="binding-option flex flex-row items-center"
            >
              <app-cover-thumbnail
                [id]="fileSettings.hardCoverFront.id"
                [color]="fileSettings.hardCoverFront.color"
                [width]="'20px'"
                [height]="'26.67px'"
              >
              </app-cover-thumbnail>
              <div class="flex flex-row items-start justify-center">
                <span class="file-text bold">Tapa delantera:</span>
                <span class="file-text overflow-hidden text-ellipsis whitespace-nowrap"
                  >({{ utils.getColorName(fileSettings.hardCoverFront.name) }})</span
                >
              </div>
            </div>
            <!-- TAPA TRASERA -->
            <div
              *ngIf="fileSettings.finishing !== Finishing.BINDING_LAMINATED && fileSettings.pageSize !== PageSize.A3"
              class="binding-option flex flex-row items-center"
            >
              <app-cover-thumbnail
                [id]="fileSettings.hardCoverBack.id"
                [color]="fileSettings.hardCoverBack.color"
                [width]="'20px'"
                [height]="'26.67px'"
              >
              </app-cover-thumbnail>
              <div class="flex flex-row items-start justify-center">
                <span class="file-text bold">Tapa trasera:</span>
                <span class="file-text overflow-hidden text-ellipsis whitespace-nowrap"
                  >({{ utils.getColorName(fileSettings.hardCoverBack.name) }})</span
                >
              </div>
            </div>
          </div>
          <ion-icon icon="assets/icon/flechaDerecha.svg"></ion-icon>
        </div>
      </ng-template>
      <ng-template #laminatingTemplate>
        <div class="lamination flex flex-row items-center justify-between" (click)="openLaminationSettings()">
          <div class="flex flex-row items-center">
            <img src="../../../assets/images/finishings/plastificado.svg" alt="" />
            <div class="flex flex-col">
              <div class="flex flex-row gap-0">
                <span class="file-text bold">Tipo plastificado:</span>
                <span class="file-text">{{ fileService.getLaminationTypeName(laminationType) }}</span>
              </div>
              <div class="flex flex-row gap-0">
                <span class="file-text bold">Grosor:</span>
                <span class="file-text"
                  >{{ fileService.getLaminationWeightName(laminationWeight, laminationType, coverLaminated) }}
                  <span *ngIf="!coverLaminated">({{ laminationWeight }} micras)</span></span
                >
              </div>
            </div>
          </div>
          <ion-icon icon="assets/icon/flechaDerecha.svg"></ion-icon>
        </div>
      </ng-template>
    </ng-container>
  </div>
  <div class="w-100 flex flex-col gap-1.5">
    <ion-button color="medium-light" (click)="cancel()">Cancelar</ion-button>
    <ion-button class="flex-1" (click)="submit()">Guardar y continuar</ion-button>
  </div>
</div>
